const VerticalLogoBanner = () => {
  return (
    <div className="w-[20px] h-full bg-[url('/images/blank_logos.png')] bg-repeat-y bg-[length:100%_400px]" />
  );
};

export { VerticalLogoBanner };
